/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Datos que envía el frontend para un item de scene_data.
 */
export interface VideoSceneDataBaseRequest { 
    play_definition_id: number;
    value: string;
    label: string;
}

